import { render, staticRenderFns } from "./FunnelChartLoading.vue?vue&type=template&id=24a719f0"
import script from "./FunnelChartLoading.vue?vue&type=script&lang=js"
export * from "./FunnelChartLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports